import { Inject, Injectable } from "@angular/core";
import { CgBusyDefaults } from "angular-busy2";
import { Observable, Subscription, Subject } from "rxjs";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from "angular-l10n";

@Injectable()
export class BusyIconService {
  busySubscription: Subscription[];
  currentMessage: string;
  currentPercentage: number;
  targetPercentage: number;
  intervalObject: any;
  private subject = new Subject<any>();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private translation: L10nTranslationService, public busyDefault: CgBusyDefaults) {
  }

  showBusyIcon(...subscription: Subscription[]) {
    this.currentMessage = this.translation.translate("GENERAL.LOADING");
    this.subject.next(subscription);
  }

  showCustomBusyIcon(message: string, ...subscription: Subscription[]) {
    this.currentMessage = message;
    this.subject.next(subscription);
  }

  showCustomPercentBusyIcon(message: string, percent: number, ...subscription: Subscription[]) {
    clearInterval(this.intervalObject);
    if (percent > this.currentPercentage) {
      if (this.currentPercentage < this.targetPercentage) {
        this.currentPercentage = this.targetPercentage;
      }
      this.targetPercentage = percent;
      this.intervalObject = setInterval(() => {
        this.currentPercentage++;
        if (this.currentPercentage >= this.targetPercentage) {
          this.currentPercentage = this.targetPercentage;
          clearInterval(this.intervalObject);
        }
        this.currentMessage = message + " " + this.currentPercentage.toString() + "%";
      }, 50);
    } else {
      this.currentPercentage = percent;
      this.targetPercentage = 0;
    }

    this.currentMessage = message + " " + this.currentPercentage.toString() + "%";
    this.subject.next(subscription);
  }

  getBusySubscription(): Observable<any> {
    return this.subject.asObservable();
  }

}
